@let data = section();

<section class="tg-section">
    <div class="cms-static tg-container">
        @if (data.staticBlockBackgroundImage?.url) {
            <cms-image
                class="cms-static__bg"
                [media]="data.staticBlockBackgroundImage"
                [fallbackAlt]="''"
            />
        }

        <div
            class="cms-static__body"
            [style.text-align]="data.staticBlockContentAlignment || null"
            [style.max-width.px]="data.staticBlockContentBlockMaxWidthPx || null"
        >
            @if (data.content) {
                <div class="cms-content" [innerHTML]="data.content | trustHtml"></div>
            }

            @if (data.items.length) {
                <ul class="cms-static__items">
                    @for (item of data.items; track item.id) {
                        <li class="cms-static__item">
                            @if (item.itemListMarker?.url) {
                                <cms-image
                                    class="cms-static__marker"
                                    [media]="item.itemListMarker"
                                />
                            }
                            <span>{{ item.itemLabel }}</span>
                        </li>
                    }
                </ul>
            }

            @if (data.buttonLink) {
                <cms-btn class="cms-static__cta" [config]="data.buttonLink" />
            }
        </div>
    </div>
</section>
